export default __webpack_public_path__ + "static/media/wedding-thumbnail-1.21510bdd.jpg";